import { fetchAuthSession } from 'aws-amplify/auth';

import { KeycloakSessionEndedError, keycloakAccessToken, usesKeycloak } from './keycloakSession';

/** There is no session to take a token from. */
export class SessionEndedError extends Error {
  constructor(message = 'Signed out: no session token to send') {
    super(message);
    this.name = 'SessionEndedError';
  }
}

/** A Hub session always supplies its access token, which the VSS services accept for both kinds (data-platform#541);
 * a Cognito session supplies the `kind` asked. Both refresh when about to expire. */
export const sessionToken = async (kind: 'accessToken' | 'idToken'): Promise<string> => {
  if (usesKeycloak()) {
    try {
      return await keycloakAccessToken();
    } catch (error) {
      throw error instanceof KeycloakSessionEndedError ? new SessionEndedError() : error;
    }
  }
  const { tokens } = await fetchAuthSession();
  const token = tokens?.[kind];
  if (!token) {
    throw new SessionEndedError();
  }
  return token.toString();
};
